import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    borderRadius: 2,
    justifyContent: 'space-around',
  },

  shade: {
    ...StyleSheet.absoluteFillObject,
  },
});

export { styles };



// WEBPACK FOOTER //
// ./src/components/third-party/Buttons/src/components/button/styles.js